import type { CommonErrors } from 'types'

export const COMMON_ERRORS: CommonErrors = {
  NO_VALID_TOKEN: 'No valid token',
  // Temporary addition, can be deleted after we migrate to Postgraphile
  HASURA_GRAPHQL_NO_VALID_TOKEN:
    'Authentication hook unauthorized this request',
}
